import { ReactNode } from 'react';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';

export interface TimelineIconGroupProps {
  icons: ReactNode[];
}

export const TimelineIconGroup = ({ icons }: TimelineIconGroupProps) => {
  return (
    <Stack>
      {icons.map((icon, idx) => (
        <Box
          key={idx}
          mb={idx + 1 === icons.length ? 0 : -3.5}
          position="relative"
          zIndex={icons.length - idx}
        >
          {icon}
        </Box>
      ))}
    </Stack>
  );
};
